import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 608,
      backgroundColor: theme.palette.common.white,
      margin: 0,
    },
    dialogTitle: {
      paddingTop: `${theme.spacing(4)}px! important`,
      padding: theme.spacing(4, 4, 2),
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightMedium,
    },
    dialogContent: {
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.shape.borderRadius,
      overflow: 'auto',
    },
    description: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
    },
    dialogActions: {
      borderTop: theme.shape.borderGray70,
      padding: theme.spacing(2, 5),
      margin: 0,
    },
    buttonClose: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
  { name: 'NoWorkspacesPopup' }
);
